export const applyThemeColors = (colors) => {
    if (!colors) return;
    const root = document.documentElement;

    const COLOR_KEYS = [
        { css: '--orange', rgbCss: '--orange-rgb', hexKey: 'orange', rgbKey: 'orangeRgb' },
        { css: '--orangeBright', rgbCss: '--orangeBright-rgb', hexKey: 'orangeBright', rgbKey: 'orangeBrightRgb' },
        { css: '--primary', rgbCss: '--primary-rgb', hexKey: 'primary', rgbKey: 'primaryRgb' },
        { css: '--BlueColor', rgbCss: '--BlueColor-rgb', hexKey: 'blueColor', rgbKey: 'blueColorRgb' },
        { css: '--BlueLight', rgbCss: '--BlueLight-rgb', hexKey: 'blueLight', rgbKey: 'blueLightRgb' },
    ];

    COLOR_KEYS.forEach(({ css, rgbCss, hexKey, rgbKey }) => {
        if (colors[hexKey]) root.style.setProperty(css, colors[hexKey]);
        if (colors[rgbKey]) root.style.setProperty(rgbCss, colors[rgbKey]);
    });

    if (colors.navbarSelected) {
        root.style.setProperty('--navbar-selected', colors.navbarSelected);
    }
};

export const applyThemeFonts = (fonts) => {
    if (!fonts) return;
    const root = document.documentElement;

    const FONT_KEYS = [
        { css: '--font-r', key: 'fontRegular' },
        { css: '--font-m', key: 'fontMedium' },
        { css: '--font-sb', key: 'fontSemiBold' },
        { css: '--font-b', key: 'fontBold' },
        { css: '--font-Black', key: 'fontBlack' },
    ];

    FONT_KEYS.forEach(({ css, key }) => {
        if (fonts[key]) root.style.setProperty(css, `'${fonts[key]}'`);
    });
};